import React, { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';
import '../../styles/app.css';
import '../../styles/metafans.scss';

import Vip from '../sections/Home/Vip.jsx';
import Genesis from '../sections/Home/Genesis.jsx';
import How from '../sections/Home/How.jsx';
import Mint from '../sections/Home/Mint.jsx';
import Meet from '../sections/Home/Meet.jsx';
import CountdownTimer from '../sections/Home/Countdown.jsx';
import Newbs from '../sections/Home/Newbs.jsx';
import Signup from '../sections/Home/Signup.jsx';
import Faqs from '../sections/Home/FAQs.jsx';
import FaqBg from '../../assets/images/faqbg.jpeg';
import bghtw from '../../assets/images/bghtw1.jpg';
import image from '../../assets/images/image.png';
import HowToWinCard from '../cards/HowToWinCard.jsx';
import HallOfFame from '../../assets/images/halloffame.svg';

function Home() {
  const cardData = [
    {
      title: 'Level 1: Holders with 1 FULL SET of all 4 MetaFans NFT Characters receive:',
      items: [
        '1 square for all MetaFans NFL Pro & NCAA College Primetime Game Square Pools',
        '1 bracket for the NCAA Basketball March Madness Challenge',
        '1 team entry PGA Major Golf challenge',
        '1 entry NBA & NHL Playoff challenges',
      ],
      flipItems: [
        
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
    {
      title: 'Level 2: Holders with 3 FULL SETS of all 4 MetaFans NFT Characters receive:',
      items: [
        'Weekly Buyin $11 NLH MetaFans Open Home Game Sundays 8pm EST at ACR Poker',
        '3 squares for All MetaFans NFL Pro & NCAA College Primetime Game Square Pools',
        '3 brackets for the NCAA Basketball March Madness Challenge',
        '3 team entries for PGA Major Golf tournament challenge',
        '3 entries into the NBA & NHL Playoffs challenges',
      ],
      flipItems: [
      
        'Anyone who enters a league they are not eligible for will forfeit prizes for all leagues that week.',
        'All prizes for leagues TBD by management',
      ],
    },
  ];

  const meta = {
    title: 'MetaFans Sports, Poker Club & More',
    description:
      'Learn about the ultimate sports-focused NFT project with the best utility!',
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const videos = [
    {
      src: 'https://drive.google.com/file/d/1xIPGJW5Xt2ibgnvjkFl7tBFNL1FUK8IH/preview',
      title: 'What is a MetaFan?',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % videos.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [videos.length]);

  return (
    <>
      <DocumentMeta {...meta}></DocumentMeta>
      <div className="theme-dk-blue min-h-screen" style={{ backgroundImage: `url(${bghtw})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
        <Vip />
        <div className="flex items-center justify-center py-0 sm:py-8 px-2 sm:px-6">
  <div className="w-full max-w-7xl m-0 sm:m-8">
    <h2 className="text-xl sm:text-3xl font-bold mb-2 sm:mb-6 text-center text-blue-400 tracking-tight">
      MetaFans in Action
    </h2>
    <div className="relative w-full bg-gray-900/80 backdrop-blur-sm p-2 sm:p-8 rounded-xl shadow-lg">
      <div
        className="relative w-full"
        style={{ paddingBottom: '56.25%' /* 16:9 aspect ratio */ }}
      >
        <div
          className="absolute top-0 left-0 w-full h-full overflow-hidden"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
            transition: 'transform 0.5s ease',
          }}
        >
          {videos.map((video, index) => (
            <iframe
              key={index}
              src={video.src}
              className="w-full h-full rounded-lg absolute top-0 left-0"
              style={{ transform: `translateX(${index * 100}%)` }}
              allow="autoplay; fullscreen"
              allowFullScreen
              title={video.title}
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>
        <div className="flex items-center justify-center py-2 sm:py-8 px-2 sm:px-6">
          <div className="grid w-full max-w-7xl grid-cols-1 gap-2 sm:gap-8 m-1 sm:m-8 md:grid-cols-2">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="bg-gray-900/80 backdrop-blur-sm p-2 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <h2 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-4 text-blue-400 tracking-tight">
                  {card.title}
                </h2>
                <ul className="space-y-1 sm:space-y-3 text-xs sm:text-base text-gray-200">
                  {card.items.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="mr-1 sm:mr-2 text-blue-400">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-2 sm:mt-6">
                  <h3 className="text-sm sm:text-lg font-semibold text-blue-400">
                    Additional Info:
                  </h3>
                  <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-300">
                    {card.flipItems.map((flipItem, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="mr-1 sm:mr-2 text-blue-400">•</span>
                        <span>{flipItem}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-center py-2 sm:py-8 px-2 sm:px-6">
          <div className="w-full max-w-7xl mx-auto m-1 sm:m-8 bg-gray-900/80 backdrop-blur-sm rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row items-center justify-center p-2 sm:p-8">
              <div className="w-full lg:w-1/2 px-2 lg:px-8 text-center lg:text-left">
                <h2 className="text-xl sm:text-3xl font-bold mb-2 sm:mb-4 text-blue-400 tracking-tight">
                  MetaFans Hall of Famer Benefits
                </h2>
                <p className="text-xs sm:text-base text-gray-200 leading-relaxed">
                  Anyone who Owns, Mints or Purchases 1 of the 18 Owner’s Box Guest Characters (OBGs) will receive ALL MetaFans Benefits, PLUS, AN ALL-EXPENSE PAID TRIP FOR 2 (4 Days & 3 Nights) for a Trip to the World Series of Poker in late June and July of 2026 as guests for an all expense paid Trip valued at $7,500 or more. Also those members that do not own an Owners Box Guest (i.e. 1 in 18 out of 10,000 Unique Metafan's OBG's), but who hold over 200 Metafans NFT's qualify as well for the all expense paid trip for the Metafans Annual Meet-up at Caesar's in Las Vegas!!!!!
                </p>
              </div>
              <div className="w-full lg:w-1/2 px-2 lg:px-8 mt-2 sm:mt-6 lg:mt-0 lg:ml-8 flex justify-center">
                <img
                  src={HallOfFame}
                  alt="MetaFans Hall of Fame"
                  className="rounded-lg w-full h-auto max-w-md object-contain transform hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
          </div>
        </div>
        <Mint />
        <Meet />
      </div>
    </>
  );
}

export default Home;